/**
 * CartNotification
 */
class CartNotification extends HTMLElement {
  constructor() {
    super()
    this.notification = document.getElementById('cart-notification')
    this.header = document.querySelector('[data-header]')
    this.onBodyClick = this.handleBodyClick.bind(this)

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())
    this.querySelectorAll('button[type="button"]').forEach((closeButton) => closeButton.addEventListener('click', this.close.bind(this)))
  }

  /**
   * open
   * @param {Boolean} hasError
   */
  open(hasError = false) {
    const errorClass = 'cart-notification--has-error'
    if (hasError) {
      this.notification.classList.add(errorClass)
    } else {
      this.notification.classList.remove(errorClass)
    }

    this.notification.classList.add('animate', 'active')
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus()
        trapFocus(this.notification)
      },
      { once: true },
    )
    document.body.addEventListener('click', this.onBodyClick)
  }

  /**
   * close
   */
  close() {
    this.notification.classList.remove('active')
    document.body.removeEventListener('click', this.onBodyClick)
    removeTrapFocus(this.activeElement)
  }

  /**
   * renderContents
   * @param {Object} parsedState
   */
  renderContents(parsedState) {
    this.productId = parsedState.id
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
    })
    this.open()
  }

  /**
   * renderQuantityError
   * @param {String} inventoryQuantity
   */
  renderQuantityError(inventoryQuantity) {
    const errorMessageElem = this.notification.querySelector('[data-cart-notification-error-message]')
    const inventoryQty = parseInt(inventoryQuantity) || 0

    errorMessageElem.innerText = window.cartStrings.quantityError.replace('[quantity]', inventoryQty)

    this.open(true)
  }

  /**
   * getSectionsToRender
   * @returns {Array} Sections to render
   */
  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ]
  }

  /**
   * getSectionInnerHTML
   * @param {String} String that contains html
   * @param {String} selector
   * @returns
   */
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
  }

  /**
   * handleBodyClick
   * @param {Object} evt
   */
  handleBodyClick(evt) {
    const target = evt.target
    if (target !== this.notification && !target.closest('cart-notification')) {
      this.close()
    }
  }

  /**
   * setActiveElement
   * @param {Node} element
   */
  setActiveElement(element) {
    this.activeElement = element
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification)
}
